import {
  addDays,
  addMonths,
  addWeeks,
  endOfMonth,
  endOfWeek,
  startOfMonth,
  startOfWeek,
  subDays,
  subMonths,
  subWeeks,
} from 'date-fns';
import { PredefinedPeriod } from './types';

const getDateValue = (option: PredefinedPeriod) => {
  const date = new Date();

  if (option.includes('Days')) {
    if (option.includes('last')) return subDays(date, option.includes('7') ? 7 : 30);
    if (option.includes('next')) return addDays(date, option.includes('7') ? 7 : 30);
  }

  if (option.includes('Month')) {
    if (option.includes('last')) return subMonths(date, 1);
    if (option.includes('next')) return addMonths(date, 1);
  }

  if (option.includes('Week')) {
    if (option.includes('last')) return subWeeks(date, 1);
    if (option.includes('next')) return addWeeks(date, 1);
  }

  return date;
};

const getFrom = (range: PredefinedPeriod) =>
  range.includes('last') ? getDateValue(range) : new Date();

const getTo = (range: PredefinedPeriod) =>
  range.includes('next') ? getDateValue(range) : new Date();

export const parseToDateRange = (range: PredefinedPeriod) => {
  const date = getDateValue(range);

  const getFromMethod = () => {
    if (range.toLocaleLowerCase().includes('today')) return;
    if (range.includes('Days')) return;
    return range.includes('Month') ? startOfMonth : startOfWeek;
  };

  const getToMethod = () => {
    if (range.toLocaleLowerCase().includes('today')) return;
    if (range.includes('Days')) return;
    return range.includes('Month') ? endOfMonth : endOfWeek;
  };

  const fromMethod = getFromMethod();
  const toMethod = getToMethod();

  return {
    range,
    from: fromMethod ? fromMethod(date) : getFrom(range),
    to: toMethod ? toMethod(date) : getTo(range),
  };
};
